import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局引入 API（可选，也可以在组件中按需引入）
import * as api from './api'

Vue.use(ElementUI)

// 将 API 挂载到 Vue 原型上，方便组件中使用
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
